import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setFormSlice } from "../../app/slices/formSlice";

import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';

import Title from "../../components/Title";
import Subtitle from "../../components/Subtitle";
import Modal from "../../components/Modal";

import "./FormUser.scss";

// para poder visualizar las imágenes en WP
const url = "/wp-content/plugins/hmg-react-app/frontend/build/";

function FormUser() {
    //variable de redux para utilizar los hooks de redux
    const dispatch = useDispatch();
    const form = useSelector(state => state.casa.form);

    //variables donde se muestran los errores
    const [errors_nombre_usuario, setErrors_nombre_usuario] = useState('');
    const [errors_cp_usuario, setErrors_cp_usuario] = useState('');
    const [errors_email_usuario, setErrors_email_usuario] = useState('');
    const [errors_telef_usuario, setErrors_telef_usuario] = useState('');
    const [errors_privacidad, setErrors_privacidad] = useState('');
    const [errors_bases, setErrors_bases] = useState('');

    //contador de validación del formulario si los campos están correctos
    let countValidacion = 0;

    //variables control errores formulario
    const [error, setError] = useState('');
    const [modalError, setModalError] = useState(false);

    //Envía el formulario de redux a la API
    const dataForm = async () => {
        try {

            const datos = {
                "auth": {
                    "hash": "OWxSMGFseXBWZ2tUQVBBPQ",
                    "partnerhash": "Mm5WVVNuS2NZeU01UFE9PQ"
                },
                "request": {
                    "type": "web",
                    "lead": {
                        "formid": "224",
                        "leaddata": form
                    }
                }
            }

            await fetch('/wp-admin/admin-ajax.php', {
                method: 'POST',
                body: new URLSearchParams({
                    action: 'process_form',
                    data: JSON.stringify(form),
                    action_url: 'form-lcqe'
                }),
                headers: {
                    "Content-type": "application/x-www-form-urlencoded; charset=UTF-8"
                }
            })
                .then(res => res.json())
                .then((result) => {

                    if (result.data.code === 200) {

                        setModalError(false);
                        const buttonNext = document.querySelector(".awssld__next");
                        buttonNext.click();

                        envioDataLayer('Formulario', form.datalayerid, form.nombre, form.email, form.telef, form.codpostal);

                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'eventData',
                            'category': 'La casa que eres',
                            'action': 'submit form'
                        });

                    } else {
                        setModalError(true);
                        const modal = document.querySelector(".modal");
                        modal.classList.remove("d-none");

                    }
                },
                    (error) => {
                        setError(error);
                        console.log('error');
                    }
                )
        } catch (error) {
            console.log("error", error);
        }
    };

    //función para recoger el dato del tlfn
    function onChangePhone() {

        const name_Telef_usuario = document.querySelector("#phone").name;
        const value_Telef_usuario = document.querySelector("#phone").value;

        //variable para coger el código del número de teléfono
        const codeTelf = document.querySelector(".selected-flag").title.replace(/\D/g, '');
        const valueTelefWithCode = codeTelf + value_Telef_usuario;

        dispatch(setFormSlice
            ({
                form: {
                    ...form,
                    [name_Telef_usuario]: valueTelefWithCode,
                }
            })
        );
    }

    //función onclick del botón submit
    function submitForm(ev) {

        ev.preventDefault();

        countValidacion = 0;

        const name_Nombre_usuario = document.querySelector("#nombre").name;
        const value_Nombre_usuario = document.querySelector("#nombre").value;
        const name_Cp_usuario = document.querySelector("#cp").name;
        const value_Cp_usuario = document.querySelector("#cp").value;
        const name_Email_usuario = document.querySelector("#email").name;
        const value_Email_usuario = document.querySelector("#email").value;
        const value_Telef_usuario = document.querySelector("#phone").value;
        const name_privacidad = document.querySelector("#privacidad").name;
        const value_privacidad = document.querySelector("#privacidad").checked;
        const name_bases = document.querySelector("#bases").name;
        const value_bases = document.querySelector("#bases").checked;

        const nombre_usuarioFeedback = document.querySelector('#nombre_usuarioFeedback');
        const cp_usuarioFeedback = document.querySelector('#cp_usuarioFeedback');
        const email_usuarioFeedback = document.querySelector('#email_usuarioFeedback');
        const telef_usuarioFeedback = document.querySelector('#telef_usuarioFeedback');
        const privacidad_usuarioFeedback = document.querySelector('#privacidadFeedback');
        const basesFeedback = document.querySelector('#basesFeedback');

        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
        const cp = /^\d{5}$/;
        const numeros = /^([0-9])*$/;

        //condiciones para la validación de los campos del formulario
        if (value_Nombre_usuario === '') {
            setErrors_nombre_usuario("Campo obligatorio.");
            nombre_usuarioFeedback.classList.replace('d-none', 'd-flex');
        } else if (value_Nombre_usuario.length < 5) {
            setErrors_nombre_usuario("Mínimo 5 caracteres.");
            nombre_usuarioFeedback.classList.replace('d-none', 'd-flex');
        } else if (value_Nombre_usuario.length > 4) {
            nombre_usuarioFeedback.classList.replace('d-flex', 'd-none');
            countValidacion += 1;
        }

        if (!cp.test(value_Cp_usuario)) {
            setErrors_cp_usuario("El código postal no es válido.");
            cp_usuarioFeedback.classList.replace('d-none', 'd-flex');
        } else if (value_Cp_usuario.length < 6) {
            cp_usuarioFeedback.classList.replace('d-flex', 'd-none');
        }

        if (value_Email_usuario === '') {
            setErrors_email_usuario("Campo obligatorio.");
            email_usuarioFeedback.classList.replace('d-none', 'd-flex');
        } else if (!regex.test(value_Email_usuario)) {
            setErrors_email_usuario("El email no es válido.");
            email_usuarioFeedback.classList.replace('d-none', 'd-flex');
        } else if (regex.test(value_Email_usuario)) {
            email_usuarioFeedback.classList.replace('d-flex', 'd-none');
            countValidacion += 1;
        }

        if (value_Telef_usuario === '') {
            setErrors_telef_usuario("Campo obligatorio.");
            telef_usuarioFeedback.classList.replace('d-none', 'd-flex');
        } else if (!numeros.test(value_Telef_usuario)) {
            setErrors_telef_usuario("El teléfono no es válido.");
            telef_usuarioFeedback.classList.replace('d-none', 'd-flex');
        } else if (value_Telef_usuario && numeros.test(value_Telef_usuario)) {
            telef_usuarioFeedback.classList.replace('d-flex', 'd-none');
            countValidacion += 1;
        }

        if (value_privacidad === false) {
            setErrors_privacidad("Campo obligatorio.");
            privacidad_usuarioFeedback.classList.replace('d-none', 'd-flex');
        } else {
            privacidad_usuarioFeedback.classList.replace('d-flex', 'd-none');
            countValidacion += 1;
        }

        if (value_bases === false) {
            setErrors_bases("Campo obligatorio.");
            basesFeedback.classList.replace('d-none', 'd-flex');
        } else {
            basesFeedback.classList.replace('d-flex', 'd-none');
            countValidacion += 1;
        }

        if (countValidacion === 5) {

            dispatch(setFormSlice
                ({
                    form: {
                        ...form,
                        [name_Nombre_usuario]: value_Nombre_usuario,
                        [name_Cp_usuario]: value_Cp_usuario,
                        [name_Email_usuario]: value_Email_usuario,
                        [name_privacidad]: value_privacidad,
                        [name_bases]: value_bases,
                    }
                })
            );

            const loading = document.querySelector('.loader-icon');
            loading.classList.remove('d-none');
            const button = document.querySelector('#form');
            button.classList.add('d-none');

            dataForm();

        }
    }

    function handleChangeInput(ev) {

        const name = ev.target.name;
        const value = ev.target.type === 'checkbox' ? ev.target.checked : ev.target.value;

        dispatch(setFormSlice({
            form: {
                ...form,
                [name]: value,
            }
        }));
    }

    /**
     * Function envioDataLayer.
     * Hace un push al datalayer con los eventos.
     *
     * @param eventAction con el tipo de acción, diferente si hay social login o no
     */
    function envioDataLayer(eventAction, datalayerid, nombre, email, phone, zipcode) {

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'la_casa_que_eres',
            'eventcategory': 'Conversiones',
            'eventaction': eventAction,
            'eventlabel': 'La Casa que eres',
            'IdForm': datalayerid,
            'user_adress': '',
            'user_city': '',
            'user_country': '',
            'user_email': email,
            'user_name': nombre,
            'user_surname': '',
            'user_phone': phone,
            'user_province': '',
            'user_zipcode': zipcode,
        });
    }

    return (

        <div className="form__content__step container">
            <div className="row form__content__step__formUser mt-3 my-md-3 my-xl-5 align-items-center">
                <div className="col-12 col-md-6 form__content__step__formUser__left">
                    <div className="form__content__step__groupTitles-formUser">
                        <Title title="Formulario de contacto" />
                        <Subtitle
                            subtitle="Para poder entrar en el sorteo y mantenerte informado sobre la casa de tus sueños, cuéntanos un poco más sobre ti." />
                    </div>
                    <img src={url + "/images/tarjeta_regalo_eci.png"} className="pt-5 d-none d-md-inline-block" />

                </div>
                <div className="col-12 col-md-6 form__content__step__formUser__right">
                    <div className="form__content__step__formUser__right-form" id="contenedor-form">
                        <form>
                            <div className="form-group mb-0 mb-md-2">
                                <label htmlFor="nombre_usuario">
                                    <Subtitle subtitle="Nombre completo" />
                                </label>
                                <input className="form-control "
                                    id="nombre"
                                    aria-describedby="nombre_usuarioFeedback"
                                    type="text"
                                    name="nombre"
                                    value={form.nombre}
                                    onChange={handleChangeInput}
                                    placeholder="Nombre y Apellidos" />
                                <div id="nombre_usuarioFeedback"
                                    className="invalid-feedback d-none">
                                    {errors_nombre_usuario}
                                </div>
                            </div>
                            <div className="form-group mb-0 mb-md-2">
                                <label htmlFor="email_usuario">
                                    <Subtitle subtitle="Email" />
                                </label>
                                <input className="form-control"
                                    aria-describedby="email_usuarioFeedback"
                                    id="email"
                                    type="email"
                                    name="email"
                                    value={form.email}
                                    onChange={handleChangeInput}
                                    placeholder="email@example.com"
                                />
                                <div id="email_usuarioFeedback"
                                    className="invalid-feedback d-none">
                                    {errors_email_usuario}
                                </div>
                            </div>

                            <div className="col-12 d-flex p-0">
                                <div className="col-6 p-0 pr-1">
                                    <div className="form-group mb-0 mb-md-2">
                                        <label htmlFor="telef">
                                            <Subtitle subtitle="Teléfono" />
                                        </label>
                                        <IntlTelInput
                                            containerClassName="intl-tel-input"
                                            inputClassName="form-control"
                                            aria-describedby="telef_usuarioFeedback"
                                            onlyCountries={["es", "be", "bg", "dk", "fi", "fr", "de", "hu", "ie", "it", "no", "pl", "ro", "se", "gb", "ru"]}
                                            defaultCountry={"es"}
                                            preferredCountries={["es"]}
                                            nationalMode={false}
                                            fieldName="telef"
                                            fieldId="phone"
                                            placeholder="612 34 56 78"
                                            onPhoneNumberChange={onChangePhone}
                                        />
                                        <div id="telef_usuarioFeedback"
                                            className="invalid-feedback d-none">
                                            {errors_telef_usuario}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6 p-0 pl-4">
                                    <div className="form-group mb-0 mb-md-2">
                                        <label htmlFor="cp_usuario">
                                            <Subtitle subtitle="Código Postal" />
                                        </label>
                                        <input className="form-control"
                                            aria-describedby="cp_usuarioFeedback"
                                            id="cp"
                                            type="text"
                                            name="cp"
                                            value={form.cp}
                                            onChange={handleChangeInput}
                                            placeholder="28046" />
                                        <div id="cp_usuarioFeedback"
                                            className="invalid-feedback d-none">
                                            {errors_cp_usuario}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="form-group mb-0">
                                <div className="form-check mb-0 mb-md-2 privacidad">
                                    <label htmlFor="privacidad" className="form-check-label">
                                        <input className="form-check-input"
                                            aria-describedby="privacidadFeedback"
                                            id="privacidad"
                                            type="checkbox"
                                            name="privacidad"
                                            value={form.privacidad}
                                            defaultChecked={false}
                                            onChange={handleChangeInput}
                                        />
                                    </label>
                                    <div className="col-12 d-flex p-0">
                                        <Subtitle subtitle="Acepto la " />
                                        <a target="_blank"
                                            href={"/politica-privacidad"}>
                                            <Subtitle subtitle="Política de privacidad" />
                                        </a>
                                    </div>

                                    <div id="privacidadFeedback"
                                        className="invalid-feedback d-none mb-2 mt-0">
                                        {errors_privacidad}
                                    </div>
                                </div>

                                <div className="form-check bases mb-0 mb-md-2">
                                    <label htmlFor="bases" className="form-check-label">
                                        <input className="form-check-input"
                                            aria-describedby="basesFeedback"
                                            id="bases"
                                            type="checkbox"
                                            name="bases"
                                            value={form.bases}
                                            defaultChecked={false}
                                            onChange={handleChangeInput}
                                        />
                                    </label>
                                    <div className="col-12 d-flex p-0">
                                        <Subtitle subtitle="Acepto las " />
                                        <a target="_blank"
                                            href={"/wp-content/uploads/2024/01/Bases-Sorteo-LA-CASA-QUE-ERES-2024.pdf"}>
                                            <Subtitle subtitle="bases legales" />
                                        </a>
                                    </div>
                                    <div id="basesFeedback"
                                        className="invalid-feedback d-none mt-0">
                                        {errors_bases}
                                    </div>
                                </div>
                            </div>

                            {/* Campos hidden para recoger valores con el social login*/}
                            <input type="hidden" id="ID_Social" name="ID_Social" />
                            <input type="hidden" id="tokenXeerpa" name="tokenXeerpa" />
                            <input type="hidden" id="formulario_entrada" name="formulario_entrada" value="29. Formulario Demanda La Casa que Eres" />
                            <input type="hidden" id="formulario_entrada_inicial" name="formulario_entrada_inicial" value="29. Formulario Demanda La Casa que Eres" />

                            <div className="pb-4 pb-md-0">
                                <button type="submit" id="form" formNoValidate="formNoValidate"
                                    onClick={submitForm} className="btn btn-primary btn-block">Enviar
                                </button>
                                <div className="btn btn-primary w-100 disabled loader-icon d-none py-0">
                                    <p className="mr-3 py-3 mb-0">Enviando</p>
                                    <i className="spin-icon animate-spin"></i>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {modalError ?
                <Modal />
                : null
            }
        </div>
    );
}

export default FormUser;
